import { Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { ActivityMetricsV2Event, ActivityMetricsV2FixedPointAudit, ActivityMetricsV2SubjectRollup } from '../../../../shared/models/activity-metrics-v2.model';
import { GlobalFunctionsService } from '../../../../services/global-functions.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

export interface ActivityMetricsSubjectMetricCard {
  metric_key: string;
  label: string;
  value: string;
  benchmark_text?: string | null;
}

@Component({
  selector: 'app-agent-performance-activity-metrics-audit-review-widget',
  templateUrl: './agent-performance-activity-metrics-audit-review-widget.component.html',
  styleUrls: ['./agent-performance-activity-metrics-audit-review-widget.component.scss']
})
export class AgentPerformanceActivityMetricsAuditReviewWidgetComponent {
  readonly headlineMetricKeys: string[] = [
    'attempt.time_instructions_to_first_actual',
    'attempt.time_instructions_to_second_actual',
    'attempt.time_first_to_second_actual',
    'attempt.time_instructions_to_third_actual',
    'attempt.time_second_to_third_actual',
    'job.time_open_to_closed_or_last_touch',
  ];

  constructor(
    public gfunc: GlobalFunctionsService,
    private modalService: BsModalService
  ) {}

  @ViewChild('templateLogReviewModal') templateLogReviewModal?: TemplateRef<any>;
  logReviewModalRef?: BsModalRef;

  @Input() selectedTimelineEvent: ActivityMetricsV2Event | null = null;
  @Input() selectedAuditRecord: ActivityMetricsV2FixedPointAudit | null = null;
  @Input() selectedSubjectRollup: ActivityMetricsV2SubjectRollup | null = null;
  @Input() selectedAttemptId: number | null = null;
  @Input() selectedSubjectId: number | null = null;
  @Input() subjectMetricCards: ActivityMetricsSubjectMetricCard[] = [];
  @Input() widget_title = 'Audit Drilldown';
  @Input() collapsed = false;

  formatBooleanFlag(value: boolean | null | undefined): string {
    return value ? 'Yes' : 'No';
  }

  get resolvedJobId(): number | null {
    return this.selectedSubjectRollup?.job_id
      ?? this.selectedTimelineEvent?.job_id
      ?? this.selectedAuditRecord?.job_id
      ?? null;
  }

  get resolvedSubjectId(): number | null {
    return this.selectedSubjectRollup?.subject_id
      ?? this.selectedTimelineEvent?.subject_id
      ?? this.selectedAuditRecord?.subject_id
      ?? this.selectedSubjectId
      ?? null;
  }

  get resolvedLogId(): number | null {
    return this.selectedTimelineEvent?.log_id ?? null;
  }

  get headlineSubjectMetricCards(): ActivityMetricsSubjectMetricCard[] {
    const metricMap = new Map(this.subjectMetricCards.map((metric) => [metric.metric_key, metric]));
    return this.headlineMetricKeys
      .map((metricKey) => metricMap.get(metricKey) ?? null)
      .filter((metric): metric is ActivityMetricsSubjectMetricCard => !!metric);
  }

  openResolvedJob(): void {
    if (this.resolvedJobId) {
      this.gfunc.globalJobViewSkipRoute(this.resolvedJobId);
    }
  }

  openResolvedSubject(): void {
    if (this.resolvedSubjectId) {
      this.gfunc.globalJobSubjectViewSkipRoute(this.resolvedSubjectId);
    }
  }

  openResolvedLog(): void {
    if (this.resolvedLogId) {
      this.gfunc.globalViewSystemLogSkipRoute(this.resolvedLogId);
    }
  }

  openResolvedLogModal(): void {
    if (!this.resolvedLogId || !this.templateLogReviewModal) {
      return;
    }

    this.logReviewModalRef = this.modalService.show(this.templateLogReviewModal, {
      class: 'modal-lg audit-log-review-modal'
    });
  }

  closeResolvedLogModal(): void {
    this.logReviewModalRef?.hide();
    this.logReviewModalRef = undefined;
  }
}
